export default __webpack_public_path__ + "static/media/boxBg.739fd562.webp";